import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { 
  MdCheckCircle, 
  MdAnalytics, 
  MdWarning, 
  MdArrowBack, 
  MdAssessment,
  MdAccessTime
} from 'react-icons/md';
import styles from './InterviewComplete.module.css';

export default function InterviewComplete() {
  const location = useLocation();
  const navigate = useNavigate();
  const { candidateId, violations = [], tabSwitchCount = 0 } = location.state || {};

  const violationTypes = {
    TAB_SWITCH: { icon: <MdArrowBack />, label: 'Tab Switch', severity: 'high' },
    RIGHT_CLICK: { icon: <MdAssessment />, label: 'Right Click', severity: 'medium' },
    DEV_TOOLS_ATTEMPT: { icon: <MdAssessment />, label: 'Dev Tools Attempt', severity: 'high' },
    MULTIPLE_FACES: { icon: <MdAssessment />, label: 'Multiple Faces', severity: 'high' },
    NO_FACE: { icon: <MdAssessment />, label: 'No Face Detected', severity: 'medium' }
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={`${styles.successIcon} ${styles.fadeIn}`}>
          <MdCheckCircle />
        </div>
        <h1 className={`${styles.title} ${styles.slideDown}`}>
          Interview Completed Successfully!
        </h1>
        
        <div className={`${styles.summaryCard} ${styles.fadeInUp}`}>
          <div className={styles.cardHeader}>
            <MdAnalytics />
            <h3>Interview Summary</h3>
          </div>
          <div className={styles.summaryGrid}>
            <div className={styles.summaryItem}>
              <p><strong>Candidate ID:</strong> {candidateId}</p>
              <p><strong>Duration:</strong> Completed</p>
              <p><strong>Status:</strong> <span className={violations.length === 0 ? styles.statusClean : styles.statusViolated}>
                {violations.length === 0 ? 'Clean Session' : `${violations.length} Violations`}
              </span></p>
            </div>
            <div className={styles.summaryItem}>
              <p><strong>Tab Switches:</strong> {tabSwitchCount}</p>
              <p><strong>Total Violations:</strong> {violations.length}</p>
              <p><strong>Timestamp:</strong> <MdAccessTime className={styles.timeIcon} /> {new Date().toLocaleString()}</p>
            </div>
          </div>
        </div>

        {violations.length > 0 && (
          <div className={`${styles.violationsCard} ${styles.fadeInUp}`}>
            <div className={styles.cardHeader}>
              <MdWarning />
              <h3>Violations Detected</h3>
            </div>
            <div className={styles.violationsList}>
              {violations.map((violation, index) => {
                const type = violationTypes[violation.type] || { icon: <MdWarning />, label: violation.type, severity: 'medium' };
                const delay = index * 0.1;
                return (
                  <div 
                    key={index} 
                    className={`${styles.violationItem} ${type.severity === 'high' ? styles.highSeverity : styles.mediumSeverity} ${styles.staggeredFadeIn}`}
                    style={{ animationDelay: `${delay}s` }}
                  >
                    <div className={styles.violationIcon}>
                      {type.icon}
                    </div>
                    <div className={styles.violationContent}>
                      <strong>{type.label}</strong>
                      <div className={styles.violationTime}>
                        {new Date(violation.timestamp).toLocaleTimeString()}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        <div className={`${styles.actionButtons} ${styles.slideUp}`}>
          <button
            onClick={() => navigate('/dashboard')}
            className={`${styles.btn} ${styles.btnSecondary}`}
          >
            <MdArrowBack />
            Back to Dashboard
          </button>
          <button
            onClick={() => navigate(`/interview/report/${candidateId}`)}
            className={`${styles.btn} ${styles.btnPrimary}`}
          >
            View Full Report
          </button>
        </div>
      </div>
    </div>
  );
}
